import React, { lazy } from 'react';
import { Route, Switch, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';

// project imports
import MainLayout from './../layout/MainLayout';
import Loadable from '../ui-component/Loadable';
import AuthGuard from './../utils/route-guard/AuthGuard';

// dashboard routing
const DashboardTerminal = Loadable(lazy(() => import('../views/dashboard/Terminal')));
const DashboardTimesheet = Loadable(lazy(() => import('../views/dashboard/Timesheet')));
const DashboardTimesheetSubmit = Loadable(lazy(() => import('../views/dashboard/TimesheetSubmit')));
const DashboardLeaveSubmission = Loadable(lazy(() => import('../views/dashboard/LeaveSubmission')));
const DashboardLeaveSubmissionFullTime = Loadable(lazy(() => import('../views/dashboard/LeaveSubmissionFullTime')));
const DashboardDefault = Loadable(lazy(() => import('../views/dashboard/Default')));
const DashboardHistory = Loadable(lazy(() => import('../views/dashboard/History')));
const UserDashboard = Loadable(lazy(() => import('../views/dashboard/User')));

// utilities routing
const UtilsTypography = Loadable(lazy(() => import('../views/utilities/Typography')));
const UtilsColor = Loadable(lazy(() => import('../views/utilities/Color')));
const UtilsShadow = Loadable(lazy(() => import('../views/utilities/Shadow')));
const UtilsMaterialIcons = Loadable(lazy(() => import('../views/utilities/MaterialIcons')));
const UtilsTablerIcons = Loadable(lazy(() => import('../views/utilities/TablerIcons')));

// sample page routing
const SamplePage = Loadable(lazy(() => import('../views/sample-page')));

//-----------------------|| MAIN ROUTING ||-----------------------//

const MainRoutes = () => {
    const location = useLocation();
    const account = useSelector((state) => state.account);
    var { isLoggedIn } = account;
    var role = false;
    var cinemaCode = false;
    const allowedCinemaCodes = [
        "NDU", "TBI", "KDV", "QTR", "TCHI", "HTP", "NVQ", "LTR", 
        "TCHA", "THS", "BTR", "CMA", "LXU", "BRI", "MIP", "HPH", 
        "VIN", "DNA", "BMT", "NTR", "PAR", "HUE", "PHI", "HNC","TAN","VVI","GBT","GAL","ATK","AHL","VDP"
      ];
    if(isLoggedIn) {
        role = account.user.role;
        cinemaCode = account.user.cinema_code;
    }


    return (
        <Route
            path={[
                '/dashboard/default',
                '/dashboard/history',
                '/dashboard/users',
                '/dashboard/timesheet',
                '/dashboard/timesheet-submit',
                '/dashboard/leave-submission',
                '/dashboard/terminal',

                '/utils/util-typography',
                '/utils/util-color',
                '/utils/util-shadow',
                '/icons/tabler-icons',
                '/icons/material-icons',

                '/sample-page'
            ]}
        >
            <MainLayout>
                <Switch location={location} key={location.pathname}>
                    <AuthGuard>
                        <Route path="/dashboard/terminal" component={DashboardTerminal} />
                        <Route path="/dashboard/timesheet" component={DashboardTimesheet} />
                        {(role == "admin" || role == "cinema_manager" ) ? <Route path="/dashboard/timesheet-submit" component={DashboardTimesheetSubmit} />: null}
                        {(role == "admin" || allowedCinemaCodes.includes(cinemaCode) ) ? <Route path="/dashboard/leave-submission" component={DashboardLeaveSubmission} />: <Route path="/dashboard/leave-submission" component={DashboardLeaveSubmissionFullTime} />}
                        <Route path="/dashboard/default" component={DashboardDefault} />
                        <Route path="/dashboard/history" component={DashboardHistory} />
                        {(role == "admin" || role == "qc_lead" ) ? <Route path="/dashboard/users" component={UserDashboard} />: null}

                        <Route path="/utils/util-typography" component={UtilsTypography} />
                        <Route path="/utils/util-color" component={UtilsColor} />
                        <Route path="/utils/util-shadow" component={UtilsShadow} />
                        <Route path="/icons/tabler-icons" component={UtilsTablerIcons} />
                        <Route path="/icons/material-icons" component={UtilsMaterialIcons} />

                        <Route path="/sample-page" component={SamplePage} />
                    </AuthGuard>
                </Switch>
            </MainLayout>
        </Route>
    );
};

export default MainRoutes;
